import React from 'react';

export default function Publication({
  children,
  withStats,
  className = '',
}) {
  return (
    <div
      className={`publication ${className} ${withStats ? `with-stats-${withStats}` : ''}`}
      data-name="publication"
    >
      { children }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Publication.js